import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiSunrunHomepageCircleImage' })(
  ({ brandColors, breakpoints, type, typography }) => ({
    container: {
      width: typography.pxToRem(220),
      height: typography.pxToRem(220),
      borderRadius: typography.pxToRem(220),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: typography.pxToRem(15),
      marginLeft: typography.pxToRem(15),
      textAlign: 'center',
      backgroundPosition: 'center center',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        width: typography.pxToRem(152),
        height: typography.pxToRem(152),
        borderRadius: typography.pxToRem(152),
        paddingLeft: typography.pxToRem(5),
        paddingRight: typography.pxToRem(5),
      },
    },
    text: {
      ...type['28_medium'],
      color: brandColors.offWhite,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        fontSize: typography.pxToRem(16),
        fontWeight: 500,
        lineHeight: typography.pxToRem(18),
        letterSpacing: '-0.02rem',
      },
    },
  })
);

export default useStyles;
